module.exports = __webpack_public_path__ + "4982702b39b79a43c96ead01f9cc6510.svg";